<template>
	<nav class="navbar">
	  <div class="container-fluid">
	    <!-- Brand and toggle get grouped for better mobile display -->
	    <div class="navbar-header">
	      <a class="navbar-brand" href="#">
	        <img class="img-responsive" alt="lasddi logo" src="../../images/lasddi-logo-sm.png">
	      </a>
	    </div>
		<h4>Usuario</h4>
	    <!-- Collect the nav links, forms, and other content for toggling -->
	    <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
	      <ul class="nav navbar-nav">
	        <li>
	          <a href="#" class="dropdown dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
	          	{{ render_name }}<span class="caret"></span>
	          </a>
	          <ul class="dropdown-menu">
	            <li><a @click="logout">Cerrar sesión</a></li>
	          </ul>
	        </li>
	      </ul>
	    </div><!-- /.navbar-collapse -->
	  </div><!-- /.container-fluid -->
	</nav>
</template>

<style scoped>
	h4{
		text-transform: none;
		float: left;
		padding-top: 20px;
		margin: 0;
	}
	.navbar{
		margin-bottom: 0;
	}
	.navbar-nav{
		float: right !important;
	}
	.navbar-header{
		width: 200px;
		text-align: center;
	}
	.navbar-header a{
		padding: 10px 40px;
	}
</style>

<script>
import { logoutUser } from '../../store/actions';

export default {
	// ------ VUEX ------
	
	vuex: {
		getters: {
			current_user: state => state.current_user
		},
		actions: {
			logoutUser
		}
	},

	// ------ RENDER ------

	computed: {
		render_name() {
			if (this.current_user.api_token) {
				return this.current_user.user.name;
			}
		}
	},

	// ------ METHODS ------

	methods: {
		logout() {
			this.logoutUser('/admin/login');
		}
	}
}
</script>


// WEBPACK FOOTER //
// Admin-navigation.vue?21f14d56